import { render } from "./NsfwDialog.vue?vue&type=template&id=08f622be&scoped=true"
import script from "./NsfwDialog.vue?vue&type=script&lang=js"
export * from "./NsfwDialog.vue?vue&type=script&lang=js"

import "./NsfwDialog.vue?vue&type=style&index=0&id=08f622be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08f622be"]])

export default __exports__